import { useEffect, useState } from "react";
import request from "project-config/services/request/request";
import useForm from "antd/es/form/hooks/useForm";
import { InoviceTabType } from "../constants";
import { useInvoiceStore } from "../store/invoice-store";
export interface IInvoiceOrderDetail {
  payRecordId: string;
  amount: number;
  payMethod: number;
  invoice: number;
  confirmDate: number;
  businessType: number;
}
interface IInvoiceOrderInfo {
  total: number;
  pageSize: number;
  pageNum: number;
  items: IInvoiceOrderDetail[];
}
interface IInvoiceOrderProps {
  payRecordId?: string;
  startTime?: [];
}

export function useInitOrderInfo() {
  const { currentInvoiceTab } = useInvoiceStore();
  const [invoiceOrderInfo, setInvoiceOrderInfo] = useState<IInvoiceOrderInfo>({
    total: 0,
    pageNum: 1,
    pageSize: 15,
    items: [],
  });
  const [invoiceOrderForm] = useForm<IInvoiceOrderProps>();
  const fetchInvoiceOrder = async (pageNum?: number) => {
    const { data } = await request.post(
      "/api/rendering/user/queryUserInvoiceOrder",
      {
        pageSize: 15,
        pageNum: pageNum,
        payRecordId: invoiceOrderForm.getFieldValue("payRecordId")
          ? invoiceOrderForm.getFieldValue("payRecordId").trim()
          : undefined,
        startTime: invoiceOrderForm.getFieldValue("startTime")
          ? new Date(invoiceOrderForm.getFieldValue("startTime")[0]).setHours(
              0,
              0,
              0,
              0
            )
          : undefined,
        endTime: invoiceOrderForm.getFieldValue("startTime")
          ? new Date(invoiceOrderForm.getFieldValue("startTime")[1]).setHours(
              23,
              59,
              59,
              59
            )
          : undefined,
      }
    );
    if (!data) return;
    setInvoiceOrderInfo(data);
  };

  useEffect(() => {
    if (currentInvoiceTab === InoviceTabType.BilledRecord) {
      invoiceOrderForm.resetFields();
      return;
    }
    fetchInvoiceOrder(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentInvoiceTab]);

  return {
    invoiceOrderInfo,
    setInvoiceOrderInfo,
    fetchInvoiceOrder,
    invoiceOrderForm,
  };
}
